import { APP_THEME_NAMES, APP_THEMES } from "@closer/shared";
import { Card, DefinitionGrid, FormField, PageHeader, Select, useToast } from "@closer/ui";

import { ApiRequestError } from "../../lib/apiClient";
import { formatDate, formatNumber } from "../../lib/format";
import { usePreferences } from "../../lib/preferences";
import { NotificationPreferencesSection } from "./NotificationPreferencesSection";

/**
 * Dil ve Görünüm (CLOS-105 `[066]`).
 *
 * ### ⚠ Dil seçicisi bugün ÇİZİLMİYOR
 *
 * Desteklenen tek dil var (`config/locale.json`, ADR-0023). Tek seçenekli bir açılır
 * liste, kullanıcıya var olmayan bir seçim sunardı (`[057]` ile aynı kural). Yerine
 * geçerli dil ve onun ürettiği BİÇİM ÖRNEĞİ gösteriliyor — kullanıcı locale'in ne işe
 * yaradığını görüyor. `config`'e ikinci bir dil eklendiğinde seçici kendiliğinden
 * görünür hale geliyor.
 */
const ORNEK_TARIH = new Date("2026-08-09T14:05:00.000Z");
const ORNEK_SAYI = 1234567.89;

export function PreferencesPage() {
  const { preferences, setTheme, setLocale, isSaving } = usePreferences();
  const toast = useToast();

  async function calistir(is: Promise<void>) {
    try {
      await is;
    } catch (error) {
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : "Tercih kaydedilemedi. Lütfen tekrar deneyin.",
      );
    }
  }

  const cokDil = preferences.supportedLocales.length > 1;

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader
        title="Tercihler"
        description="Görünüm, dil/biçim ve bildirim tercihlerinizi yönetin."
      />

      <Card title="Görünüm">
        <FormField label="Tema">
          <Select
            value={preferences.theme}
            disabled={isSaving}
            onChange={(event) =>
              void calistir(setTheme(event.target.value as (typeof APP_THEMES)[number]))
            }
          >
            {APP_THEMES.map((tema) => (
              <option key={tema} value={tema}>
                {APP_THEME_NAMES[tema]}
              </option>
            ))}
          </Select>
        </FormField>
        <p className="mt-2 text-xs text-fg-soft">
          Sistem seçildiğinde tema, cihazınızın görünüm ayarını takip eder.
        </p>
      </Card>

      <Card title="Dil ve Biçim">
        {cokDil ? (
          <FormField label="Uygulama dili">
            <Select
              value={preferences.locale}
              disabled={isSaving}
              onChange={(event) => void calistir(setLocale(event.target.value))}
            >
              {preferences.supportedLocales.map((kod) => (
                <option key={kod} value={kod}>
                  {kod}
                </option>
              ))}
            </Select>
          </FormField>
        ) : (
          <p className="text-sm text-fg-muted">
            Uygulama dili: <span className="font-medium text-fg">Türkçe</span>
          </p>
        )}

        {/* Biçim ÖRNEĞİ: locale'in ne yaptığını soyut anlatmak yerine göstermek. */}
        <DefinitionGrid
          className="mt-3"
          items={[
            {
              key: "tarih",
              label: "Tarih",
              value: (
                <span data-testid="ornek-tarih">{formatDate(ORNEK_TARIH, preferences.locale)}</span>
              ),
            },
            {
              key: "sayi",
              label: "Sayı",
              value: (
                <span data-testid="ornek-sayi">{formatNumber(ORNEK_SAYI, preferences.locale)}</span>
              ),
            },
          ]}
        />
      </Card>

      {/*
        ⚠ Bildirim tercihleri BURADA (CLOS-187 `[169]`): kanal ayarı bir hesap tercihi ve
        kullanıcı onu dil/tema ile aynı yerde arıyor. Bildirim Merkezi bir OKUMA yüzeyi ve
        aktif çalışma alanına bağlı; tercih ise kişiye ait — ikisini aynı ekrana koymak,
        alan değiştirince tercihlerin de değiştiği izlenimini verirdi.
      */}
      <NotificationPreferencesSection />
    </div>
  );
}
